// src/components/CharacterSelect.js
import React from "react";

const CharacterSelect = ({ characters,  onSelectCharacter, selectedCharacter }) => {

  const getIconPath = (character) => {
    return `/icons/${character}_0.webp`;
  }

  return (
    <div className="grid grid-cols-8 grid-rows-3 lg:grid-cols-12 lg:grid-rows-2 gap-2 ">
      {characters.map((character) => (
        <div
          key={character}
          className="cursor-pointer justify-center items-center"
          onClick={() => onSelectCharacter(character)}
        >
          {/* Replace with your character icon component */}
          <img src={getIconPath(character)} alt="" className={`w-7 h-7 rounded-full border border-gray-300 transition-colors hover:opacity-100 transition-full" ${
            selectedCharacter === character ? 'border-pink-500 bg-pink-500/60 opacity-100' : 'opacity-90 hover:border-pink-500'
          }`}
          
          />
        </div>
      ))}
    </div>
  );
};

export default CharacterSelect;